// extracted by mini-css-extract-plugin
module.exports = {"container":"titleAndLink_container__HfvOm"};